/* Stylesheet */

.table_slide {
  padding: 0;

  .row {
    padding: 0px 32px 0px 32px;
    display: flex;
    height: 52px;
    align-items: center;
  }

  .col {
    padding: 0;
    display: flex;
    align-items: center;
  }

  .label_col {
    .label {
      display: flex;
      line-height: 1.75;
      align-items: center;
    }
  }

  .value_col {
    .value {
      width: 92px;
    }

    .suffix {
      margin: 0px 0px 0px 12px;
      font-size: 0.75rem;
      color: var(--ion-color-text-tertiary);
    }
  }
}
